import { render, staticRenderFns } from "./BlogIndex.vue?vue&type=template&id=703709d6&scoped=true"
import script from "./BlogIndex.vue?vue&type=script&lang=js"
export * from "./BlogIndex.vue?vue&type=script&lang=js"
import style0 from "./BlogIndex.vue?vue&type=style&index=0&id=703709d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703709d6",
  null
  
)

export default component.exports